import styled from "styled-components";
import { Div, Header } from "components";

export const Wrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const StyledHeader = styled(Header)``;

export const ContentWrapper = styled.section`
  min-height: calc(100vh - 177px);
  display: flex;
  flex-direction: column;
  margin-top: 81px;
  align-items: center;
  flex-grow: 1;
`;
